import { createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "login-wrap"
};
const _hoisted_2 = {
  class: "holder holder-fluid"
};
const _hoisted_3 = {
  class: "login"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, "Придумайте Новый пароль", -1);

const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "password"
}, "Новый пароль", -1);

const _hoisted_6 = {
  class: "pass"
};
const _hoisted_7 = ["type"];

const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "label",
  for: "password-two"
}, "Подтвердите пароль", -1);

const _hoisted_9 = {
  class: "pass"
};
const _hoisted_10 = ["type"];

const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "form-button"
}, [/*#__PURE__*/_createElementVNode("button", {
  class: "button"
}, "Изменить пароль")], -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("form", {
    onSubmit: _cache[4] || (_cache[4] = _withModifiers((...args) => $options.handlerSubmit && $options.handlerSubmit(...args), ["prevent"]))
  }, [_createElementVNode("fieldset", null, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.password = $event),
    id: "password",
    type: $options.passwordType,
    class: "input",
    placeholder: "Введите пароль"
  }, null, 8, _hoisted_7), [[_vModelDynamic, $data.form.password]]), _createElementVNode("a", {
    style: {
      "cursor": "pointer"
    },
    class: "show-pass",
    onClick: _cache[1] || (_cache[1] = $event => $data.hiddenPassword = !$data.hiddenPassword)
  })]), _hoisted_8, _createElementVNode("div", _hoisted_9, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.passwordTwo = $event),
    id: "password-two",
    type: $options.passwordTwoType,
    class: "input",
    placeholder: "Введите пароль"
  }, null, 8, _hoisted_10), [[_vModelDynamic, $data.passwordTwo]]), _createElementVNode("a", {
    style: {
      "cursor": "pointer"
    },
    class: "show-pass",
    onClick: _cache[3] || (_cache[3] = $event => $data.hiddenPasswordTwo = !$data.hiddenPasswordTwo)
  })]), _hoisted_11])], 32)])])]);
}